import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import './App.css';
import FormPage from './FormPage';
import AchievementPage from './AchievementPage'; // Import the AchievementPage component

// Replace these imports with your actual file names located in /src/assets.
import mindLogo from './assets/company_logo.jpeg';
import userImage from './assets/profile_pic.jpeg';
import productImage from './assets/product_image.png';

function App() {
  return (
    <Router>
      <div className="App">
        {/* Navigation Bar */}
        <nav className="navbar">
          <div className="nav-left">
            <Link to="/">
              <img src={mindLogo} alt="Company Logo" className="company-logo" />
            </Link>
            <Link to="/" className="company-name-link">
              <h1 className="company-name">Bare Metal Syndicate</h1>
            </Link>
          </div>
          <div className="nav-right">
            <Link to="/form" className="nav-button">Form</Link>
            <Link to="/achievement" className="nav-button">Achievement</Link> {/* Add the Achievement link */}
            <a href="https://poe.com/mentor_mitra_ai" className="nav-button" target="_blank" rel="noopener noreferrer">
              🤖 Chat with me
            </a>
            <img src={userImage} alt="User" className="user-image" />
          </div>
        </nav>

        {/* Main Page Content */}
        <Routes>
          <Route path="/" element={
            <div className="home-page">
              <div className="product-image-container">
                <img src={productImage} alt="Product" className="product-image" />
              </div>
              <div className="product-info">
                <h1>Mentor Mitra AI</h1>
                <p>
                  The RoboMentor AI Kit is an innovative educational toy that combines
                  robotics with generative AI. Children build and program robots
                  while receiving dynamic, personalized support, enhancing both
                  their confidence and sense of accomplishment.
                </p>
                <ul>
                  <li><strong>Interactive Guidance System:</strong> Real-time tips, troubleshooting, and motivational feedback</li>
                  <li><strong>Adaptive Learning Pathways:</strong> Tasks adjust to each child's progress for balanced challenges</li>
                  <li><strong>Creative Exploration Mode:</strong> Inspires open-ended design and programming experimentation</li>
                  <li><strong>Achievement Tracking and Rewards:</strong> Celebrates milestones with digital badges</li>
                  <li><strong>Collaborative Challenges:</strong> Facilitates teamwork and idea exchange with peers</li>
                </ul>
                <p className="product-price">₹29,999</p>
                <Link to="/form" className="buy-button">Buy Now</Link>
                <a href="https://poe.com/mentor_mitra_ai" className="big-chat-button" target="_blank" rel="noopener noreferrer">
                  🤖<br />Chat with me
                </a>
              </div>
            </div>
          } />
          <Route path="/form" element={<FormPage />} />
          <Route path="/achievement" element={<AchievementPage />} /> {/* Add the Achievement route */}
        </Routes>

        {/* Footer */}
        <footer className="footer">
          <p>© 2025 Mitra Minds - All rights reserved.</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
